import api from 'axios'
import { URL_BACK } from '../../variableProd'
/**
 * Servicio para autenticación y administración de usuarios.
 * @module ServicioUsuarios
 */
const logIn = URL_BACK + '/usuario/login.php'
const registrar = URL_BACK + '/usuario/registro.php'
const getGerente = URL_BACK + '/usuario/getGerente.php'

const logOut = URL_BACK + '/usuario/logoutUsuario'

const getmisUsuarios = URL_BACK + '/usuario/getUsuarios'
const deletemiUsuario = URL_BACK + '/usuario/eliminarUsuario'
const cierraSesion = URL_BACK + '/usuario/logoutUsuario'
const privilegio = URL_BACK + '/usuario/editarPrivilegioReactivar'
/**
 * Funciones para autenticación y administración de usuarios.
 */

export default {
  /**
   * Inicia sesión de un usuario.
   * @param {object} model - Modelo de inicio de sesión.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  logIn (model) {
    return new Promise((resolve, reject) => {
      api
        .post(logIn, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
   /**
   * Cierra la sesión de un usuario.
   * @param {object} model - Modelo de cierre de sesión.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  logOut (model) {
    return new Promise((resolve, reject) => {
      api
        .post(logOut, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Registra un nuevo usuario.
   * @param {object} model - Modelo de registro de usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  registrar (model) {
    return new Promise((resolve, reject) => {
      api
        .put(registrar, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Obtiene los datos del Gerente Asociado.
   * @param {object} model - Modelo de registro de usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  getGerente (model) {
    console.log(model)
    return new Promise((resolve, reject) => {
      api
        .put(getGerente, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Obtiene lista de usuarios.
   * @param {object} model - Modelo de obtener a usuarios.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  getUsuarios (model) {
    return new Promise((resolve, reject) => {
      api
        .post(getmisUsuarios, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Cierra sesion de  usuario.
   * @param {object} model - Modelo de usuario a cerrar sesion.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  cerrarSesion (model) {
    return new Promise((resolve, reject) => {
      api
        .post(cierraSesion, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Editar privilegio a un usuario.
   * @param {object} model - Modelo de editar privilegio a  usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  editarPrivilegio (model) {
    return new Promise((resolve, reject) => {
      api
        .post(privilegio, model
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Eliminar un usuario.
   * @param {object} model - Modelo de Eliminar de  un usuario.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  deleteUsuarios (model) {
    return new Promise((resolve, reject) => {
      api
        .delete(deletemiUsuario, {data:model})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
}
